import { backofficeRequest } from '../../axios'
import { DRAFT_TICKET_TYPE } from '../../zendesk/ZendeskModal'

export const getZendeskTickets = async (ticketId, type) => {
  try {
    if (type === DRAFT_TICKET_TYPE) {
      const res = await backofficeRequest.get(
        `backoffice/tickets-drafts/${ticketId}/zendesk-tickets`
      )
      return res.data
    } else {
      const res = await backofficeRequest.get(
        `backoffice/tickets/${ticketId}/zendesk-tickets`
      )
      return res.data
    }
  } catch (error) {
    return error.response
  }
}

export const unlinkZendeskTicket = async (ticketId, zendeskTicketId, type) => {
  try {
    if (type === DRAFT_TICKET_TYPE) {
      return await backofficeRequest.delete(
        `backoffice/tickets-drafts/${ticketId}/zendesk-tickets/${zendeskTicketId}`
      )
    } else {
      return await backofficeRequest.delete(
        `backoffice/tickets/${ticketId}/zendesk-tickets/${zendeskTicketId}`
      )
    }
  } catch (error) {
    return error.response
  }
}

export const searchZendeskTickets = async (query) => {
  try {
    const res = await backofficeRequest.get(`zendesk/search?query=${query}`)
    return res.data
  } catch (error) {
    return error.response
  }
}

export const linkZendeskTickets = async (ticketId, zendeskTickets, type) => {
  try {
    if (type === DRAFT_TICKET_TYPE) {
      await backofficeRequest.post(
        `backoffice/tickets-drafts/${ticketId}/zendesk-tickets`,
        zendeskTickets
      )
    } else {
      await backofficeRequest.post(
        `backoffice/tickets/${ticketId}/zendesk-tickets`,
        zendeskTickets
      )
    }
  } catch (error) {
    return error.response
  }
}
